import React, { useEffect, useState } from "react";
import { Validator } from "./validator";
import { useFormik } from "formik";
import {
  Container,
  SubHeading,
  Header,
  Label,
  Input,
  NextBtn,
  CancelBtn,
  ComfirmText,
} from "../logIncident/logIncident.style";

const NextIncidentLog = ({
  handleCloseModal,
  next,
  handleIncidentLog,
}: any) => {
  const [confirm, setConfirm] = useState(false);
  const formik = useFormik({
    initialValues: {
      name: "",
      agency: "",
      shiftWorked: "",
      unitAssignment: "",
      SSN: "",
    },
    validationSchema: Validator(),
    onSubmit: (values) => {
      handleIncidentLog(values);
    },
  });

  const checkboxChange = (e: any) => {
    setConfirm((prevState) => !prevState);
  };

  useEffect(() => {
    let ssn = formik.values.SSN.toString();
    formik.setValues({
      ...formik.values,
      SSN: ssn.substring(0, 4),
    });
  }, [formik.values.SSN]);

  return (
    <Container>
      <div className="flex">
        <div
          onClick={() => handleCloseModal()}
          className="cursor-pointer text-2xl font-medium"
        >
          &times;
        </div>

        <Header>
          Log New Incident <SubHeading> (Guest Staff) </SubHeading>{" "}
        </Header>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="mt-7">
          <div className="mb-4">
            <Label>What is your name?</Label>
            <Input
              placeholder="Enter Full Name"
              name="name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="text-sm text-red-500">{formik.errors.name}</div>
            )}
          </div>

          <div className="mb-4">
            <Label>What agency do you work for?</Label>
            <Input
              placeholder="Enter text"
              name="agency"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.agency && formik.errors.agency && (
              <div className="text-sm text-red-500">{formik.errors.agency}</div>
            )}
          </div>

          <div className="mb-4">
            <Label>Shift worked</Label>
            <Input
              placeholder="Enter text"
              name="shiftWorked"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.shiftWorked && formik.errors.shiftWorked && (
              <div className="text-sm text-red-500">
                {formik.errors.shiftWorked}
              </div>
            )}
          </div>

          <div className="mb-4">
            <Label>Unit Assignment</Label>
            <Input
              placeholder="Enter text"
              name="unitAssignment"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.unitAssignment && formik.errors.unitAssignment && (
              <div className="text-sm text-red-500">
                {formik.errors.unitAssignment}
              </div>
            )}
          </div>

          <div className="mb-4">
            <Label>Last four digits of SSN</Label>
            <Input
              placeholder="Enter text"
              name="SSN"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              type="number"
              value={formik.values.SSN}
            />
            {formik.touched.SSN && formik.errors.SSN && (
              <div className="text-sm text-red-500">{formik.errors.SSN}</div>
            )}
          </div>
        </div>

        <div>
          <input type="checkbox" onChange={checkboxChange} checked={confirm} />
          <ComfirmText>
            I confirm the information provided above is correct
          </ComfirmText>
        </div>

        <div className="mt-14">
          {/* @ts-ignore */}
          <NextBtn className="mr-2" type="submit" disabled={!confirm}>
            Next
          </NextBtn>
          <CancelBtn type="button" onClick={() => handleCloseModal()}>
            Cancel
          </CancelBtn>
        </div>
      </form>
    </Container>
  );
};

export default NextIncidentLog;
